import { fetchApi } from './api';

export const getShops = async (page = 1, limit = 25, search = '') => {
  const params = new URLSearchParams({ page, limit });
  if (search) {
    params.append('search', search);
  }
  return fetchApi(`/shops?${params.toString()}`, { method: 'GET' });
};

export const createShop = async (shopData) => {
  return fetchApi('/shops', {
    method: 'POST',
    body: shopData,
  });
};

export const updateShop = async (id, shopData) => {
  return fetchApi(`/shops/${id}`, {
    method: 'PUT',
    body: shopData,
  });
};

export const deleteShop = async (id) => {
  return fetchApi(`/shops/${id}`, {
    method: 'DELETE',
  });
};